import React from 'react'
import { useLocal } from 'Source/App/Storage/Local';
import { isColorDark, colorShade } from 'Common/Utils';
import { localkey } from 'Source/App/Main/local-config';
import { boxShadowFactory, Stylesheet } from './stylesheet';
import { HeadGear } from 'Templates';
const getShadowPosition = ({intensity, color, lightSource}) => {
    const colorHSP =  isColorDark(color, true)
    const darkShade = {
		color: colorShade(colorHSP < 30 ? '#333333' : color, intensity * -1),
		x:(distance) => distance * (['bottom-right', 'top-right'].includes(lightSource) ? -1 : 1),
		y:(distance) => distance * (['bottom-right', 'bottom-left'].includes(lightSource) ? -1 : 1),
	};
	const lightShade = {
		color: colorShade(colorHSP < 30 ? '#555555' : color, color === '#ffffff' ? -1 : intensity),
		x:(distance) =>  distance * (['top-left', 'bottom-left'].includes(lightSource) ? -1 : 1),
		y:(distance) =>  distance * (['top-left', 'top-right'].includes(lightSource) ? -1 : 1),
    };

    return {
        darkShade,
        lightShade
    }
}
const ShadowDanceFactory = ({intensity, color, lightSource, inset, light, dark }) => {
    const { lightShade, darkShade } = getShadowPosition({intensity, color, lightSource})
    const insetOrNot = inset ? ' inset ' : ' '
    const notOrInset = !inset ? ' inset ' : ' '
    return `box-shadow:${insetOrNot}${lightShade.x(light.x)}px ${lightShade.y(light.y)}px ${light.blur}px ${lightShade.color},${insetOrNot}${darkShade.x(dark.x)}px ${darkShade.y(dark.y)}px ${dark.blur}px ${darkShade.color},${notOrInset}0px 0px 0px ${lightShade.color},${notOrInset}-0px -0px 0px ${darkShade.color};`
}
export const OverideStylesheet = () => {
    const { getLocal } = useLocal();
	const { color, textColor, lightSource } = getLocal(localkey.general);
	const { intensity, distance, blur } = getLocal(localkey.freestyle);
	const isDarkBackground = isColorDark(color);
    const textBaseColor = colorShade(textColor, 10)
    const borderColor = colorShade(color, isColorDark(color, true) > 100 ? -5 : 10)
    const commonSetting = {intensity, color, lightSource}
    const { lightShade, darkShade } = getShadowPosition({intensity, color, lightSource})
    return ( 
        <>
            <HeadGear>
                <meta name="theme-color" content={color} />
                <meta name="text-color" content={textColor} />
            </HeadGear>
            <style>
{`[data-color-changable="true"] { 
    color: ${textColor} !important
}
#home > .scroll-down:before,
#home > .scroll-down:after {
    border: 2px solid ${textColor};
}
.custom-letter-filter > li > a {
    color: ${textColor};
}
.rt-pagination > li > a,
.rt-pagination > li > span {
    background-color: ${color};
    border-color: ${borderColor};
}
.reatable > .reatable-content > table:not([class]) th,
.reatable > .reatable-content > table:not([class]) td {
    border-color: ${borderColor};
}
.btn-caret:before, .btn-caret:after {
    background: ${textColor} !important;
}
.mobile-tip:before {
    background-color: ${textBaseColor};
}
.mobile-backdrop {
    background-color: ${borderColor};
}
img[alt="beard-guy"], img[alt="mytabworks"], .Facade_facadePara__6lE3x > ul > li, .Facade_facadeTitle__3mJJj  {
    filter: invert(${isDarkBackground ? 1 : 0}) !important
}
.nav-sidebar,
.side-panel {
    background-color: ${color};
}
@media screen and (max-width: 500px) {
    .nav-sidebar {
        ${boxShadowFactory({ ...commonSetting, distance: distance/2, blur: blur/2, hill: true, allowBorder: false})}
    }
}
@media screen and (max-width: 769px) {
    .side-panel { 
        ${boxShadowFactory({ ...commonSetting, distance: distance/2, blur: blur/2, hill: true, allowBorder: false})}
    }
}
@keyframes shadow-dance {
    0% {
        box-shadow: ${lightShade.x(distance)}px ${lightShade.y(distance)}px ${blur}px ${lightShade.color}, ${darkShade.x(distance)}px ${darkShade.y(distance)}px ${blur}px ${darkShade.color}, inset ${lightShade.x(distance)}px ${lightShade.y(distance)}px ${blur}px ${lightShade.color}, inset ${darkShade.x(distance)}px ${darkShade.y(distance)}px ${blur}px ${darkShade.color};
    }
    50% {
        ${ShadowDanceFactory({...commonSetting, light: {x: 2, y: 5, blur: 10}, dark: {x: 10, y: 14, blur: 19}})}
    }
    100% {
        ${ShadowDanceFactory({...commonSetting, light: {x: 12, y: 5, blur: 15}, dark: {x: 5, y: 3, blur: 10}})}
    }
}
@keyframes shadow-dance-flat {
    0% {
        ${ShadowDanceFactory({...commonSetting, light: {x: distance, y: distance, blur}, dark: {x: distance, y: distance, blur}})}
    }
    50% {
        ${ShadowDanceFactory({...commonSetting, light: {x: 2, y: 5, blur: 10}, dark: {x: 10, y: 14, blur: 19}})}
    }
    100% {
        ${ShadowDanceFactory({...commonSetting, light: {x: 12, y: 5, blur: 15}, dark: {x: 5, y: 3, blur: 10}})}
    }
}
@keyframes shadow-dance-engrave {
    0% {
        ${ShadowDanceFactory({...commonSetting, inset: true, light: {x: distance, y: distance, blur}, dark: {x: distance, y: distance, blur}})}
    }
    50% {
        ${ShadowDanceFactory({...commonSetting, inset: true, light: {x: 2, y: 5, blur: 10}, dark: {x: 10, y: 14, blur: 19}})}
    }
    75% {
        ${ShadowDanceFactory({...commonSetting, inset: true, light: {x: 0, y: 0, blur: 0}, dark: {x: 2, y: 5, blur: 10}})}
    }
    100% {
        ${ShadowDanceFactory({...commonSetting, inset: true, light: {x: 12, y: 5, blur: 15}, dark: {x: 5, y: 3, blur: 10}})}
    }
}`}
            </style>
        </>
    )
}

export const DynamicStylesheet = () => (
    <style id="stylesheet">
        <Stylesheet />
    </style>
)